module.exports = __webpack_public_path__ + "img/nophoto.495e862d.jpg";